export default function getItemIndexFromArray<T>(array: Array<T>, item: T): number {
	return array.findIndex((cur) => cur === item);
}
